import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { AdminLogin } from "../components/admin/AdminLogin";
import { AdminHeader } from "../components/admin/AdminHeader";
import { DashboardPanel } from "../components/admin/dashboard/DashboardPanel";
import { AdminCityEditor } from "../components/admin/AdminCityEditor";
import { StudioPanel } from "../components/admin/studio/StudioPanel";
import { SettingsPage } from "../components/admin/SettingsPage";
import { WargaPanel } from "../components/admin/WargaPanel";
import OfficePage from "../components/office/OfficePage";

// Admin — dashboard (statistik + pusat konten) + editor kota + studio AI + pengaturan (walikota)
// Bagian-bagian: components/admin/{AdminLogin,AdminHeader,AdminCityEditor}, admin/dashboard/*, admin/studio/*
export default function Admin() {
  const [token, setToken] = useState(localStorage.getItem("admin_token") || "");
  const [tab, setTab] = useState("dashboard");
  const [dashKey, setDashKey] = useState(0); // klik ulang tab Dashboard → kembali ke ringkasan (tutup panel konten)
  const [unread, setUnread] = useState(0);   // pesan warga belum dibaca → lencana merah di tab Dashboard (cek tiap 60 dtk)
  useEffect(() => {
    if (!token) return;
    let alive = true;
    const cek = () => api.adminPesanUnread(token).then(d => { if (alive) setUnread(d.unread || 0); }).catch(() => {});
    cek();
    const t = setInterval(cek, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [token, tab]);

  function logout() {
    localStorage.removeItem("admin_token");
    setToken("");
  }

  if (!token) return <AdminLogin onLogin={setToken} />;

  // Semua tab memakai tema terang universal (Medium Blue + kartu putih)
  const dashBg = "radial-gradient(1100px 620px at 15% -5%, #f8f5e8, #efece0 70%)";
  const scroll = { flex: 1, minHeight: 0, overflowY: "auto" };

  return (
    <div style={{ height: "100vh", overflow: "hidden", display: "flex", flexDirection: "column", background: dashBg, color: "#141414", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <AdminHeader tab={tab} unread={unread} onTab={setTab} onDashboardAgain={() => setDashKey(k => k + 1)} onLogout={logout} />
      {tab === "dashboard" ? <DashboardPanel key={dashKey} token={token} onTab={setTab} />
        : tab === "warga" ? <div style={scroll}><WargaPanel token={token} /></div>
        : tab === "editor" ? <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}><AdminCityEditor token={token} /></div>
        : tab === "settings" ? <div style={scroll}><SettingsPage token={token} /></div>
        : tab === "office" ? <OfficePage token={token} />
        : <div style={scroll}><StudioPanel token={token} /></div>}
    </div>
  );
}
